import { useQuery } from '@tanstack/react-query'

import { queryKeys } from 'api/consts'

import { fetchOnboardingTips } from './api'

export const useOnboardingTipsDataQuery = () =>
  useQuery({
    queryFn: fetchOnboardingTips,
    queryKey: [queryKeys.onboardingTips],
  })
